import { Controller } from "@hotwired/stimulus";
import { getScoreFunctionPreservingOrderInSearch, selectize } from "../../../../../../scripts/selectizeHelper";
import { PointOfInterestCategory } from "../../../../../../scripts/_generated/PointOfInterestCategory";

export default class CommonInformationController extends Controller {
    static targets = [
        "category",
        "subcategory"
    ];

    readonly categoryTargets!: HTMLInputElement[];
    readonly subcategoryTarget!: HTMLElement;

    connect() {
        this.onCategoryChangeOptionallyResetSubcategory();
    }

    onCategoryChangeOptionallyResetSubcategory() {

        selectize($(this.subcategoryTarget), {
            score: getScoreFunctionPreservingOrderInSearch
        });
        const subcategorySelectize = $(this.subcategoryTarget)[0].selectize;

        $(this.categoryTargets).change(() => {
            const selectedCategory = this.categoryTargets.find(x => x.checked)?.value;
            const isPracticalCategory = selectedCategory === `${PointOfInterestCategory.Practical}`;
            if (isPracticalCategory) {
                subcategorySelectize.enable();
            } else {
                subcategorySelectize.setValue("", false);
                subcategorySelectize.disable();
            }
        });
    }
}
